const ReferralCardCreationConstants = {
    displayTitleCharacterLength : 20,
    subTitleCharacterLength : 20,
    minimumLength : 0
}

export default ReferralCardCreationConstants;
